import { render, staticRenderFns } from "./FinishedProduct.vue?vue&type=template&id=6e4b1ebb&"
import script from "./FinishedProduct.vue?vue&type=script&lang=js&"
export * from "./FinishedProduct.vue?vue&type=script&lang=js&"
import style0 from "./FinishedProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports